import { useDispatch, useSelector } from 'react-redux'

export default function useFilter(key = '') {
  const dispatch = useDispatch()
  const filter = useSelector(state => state.filters[key])
  const allFilters = useSelector(state => state.filters)

  const toggleFilter = () => {
    dispatch({
      type: '@filter/TOGGLE',
      key,
    })
  }

  const setFilter = value => {
    dispatch({
      type: '@filter/SET',
      key,
      value,
    })
  }

  const resetAllFilters = () => {
    dispatch({
      type: '@filter/RESET',
    })
  }

  return {
    toggleFilter,
    setFilter,
    filter,
    resetAllFilters,
    allFilters,
  }
}
